import React from "react";
import classnames from "classnames";

import { MenuItem } from "custom-types/MenuItem";

import CircleCheckMarkIcon from "components/Icons/circle_check_mark.svg";

type Props = {
  menuItem: Pick<
    MenuItem,
    "isTrending" | "isBestSeller" | "isNew" | "isStaffPick"
  >;
  similarStrain?: boolean;
  isFeatured?: boolean;
};

const CardFlag: React.FC<Props> = ({
  menuItem,
  similarStrain = false,
  isFeatured,
}) => {
  const { isTrending, isBestSeller, isNew, isStaffPick } = menuItem || {};

  // Staff pick has unique styling
  let showStaffPick = false;
  let displayText;

  if (similarStrain) {
    displayText = "Similar strain";
  } else if (isTrending) {
    displayText = "Trending now";
  } else if (isBestSeller) {
    displayText = "Best seller";
  } else if (isNew) {
    displayText = "New";
  } else if (isStaffPick) {
    displayText = "Staff pick";
    showStaffPick = true;
  }

  if (isFeatured) {
    displayText = "Featured";
    showStaffPick = false;
  }

  if (!displayText) {
    return null;
  }

  return (
    <div className="absolute z-10 top-0 left-0 flex" data-testid="card-flag">
      <div
        className={classnames(
          "inline-flex items-center font-bold leading-none text-xs p-sm",
          {
            "text-default bg-light-grey": !showStaffPick,
          }
        )}
        style={{ borderBottomRightRadius: "12px" }}
      >
        {showStaffPick && (
          <span className="text-green mr-xs">
            <CircleCheckMarkIcon height="14" width="14" />
          </span>
        )}
        {similarStrain && (
          <div className="mr-xl">
            <div className="absolute mr-sm z-10">
              <span
                className="border border-default absolute"
                style={{
                  borderRadius: "50%",
                  bottom: -5,
                  height: 10,
                  width: 10,
                }}
              />
              <span
                className="border border-default absolute"
                style={{
                  borderRadius: "50%",
                  bottom: -5,
                  height: 10,
                  left: 5,
                  width: 10,
                }}
              />
            </div>
          </div>
        )}
        {displayText}
      </div>
    </div>
  );
};

export default CardFlag;
